(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["arknights-gacha-recorder-webui"] = factory();
	else
		root["arknights-gacha-recorder-webui"] = factory();
})(globalThis, () => {
return 